module.exports = "/_next/static/images/slide4-2fd499b33c56f29919077a0cac948599.webp";